import React from 'react';
import { CheckIcon } from 'lucide-react';
export const SolutionSection = () => {
  const features = [{
    title: 'Exclusive Design',
    description: 'Inspired by the jersey that unites all his career stages.'
  }, {
    title: 'Limited & Numbered',
    description: 'Only a fixed quantity exists. Once sold out, no reprints will ever be made.'
  }, {
    title: 'Certificate of Authenticity',
    description: 'Every copy sealed, numbered, and tracked — ensuring provenance.'
  }, {
    title: 'Premium Finishes',
    description: 'Built to display proudly in your library, office, or trophy room.'
  }];
  return <div className="bg-gray-900 text-white py-16" data-id="element-175">
      <div className="container mx-auto px-4" data-id="element-176">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-177">
          The Solution: The Legacy #7 Edition
        </h2>
        <p className="text-center mb-12 text-gray-300 max-w-2xl mx-auto" data-id="element-178">
          That's why we created The History of Cristiano Ronaldo — Limited
          Legacy #7 Collector's Edition.
        </p>
        <div className="grid md:grid-cols-2 gap-8" data-id="element-179">
          {features.map((feature, index) => <div key={index} className="flex items-start p-6 bg-gray-800 rounded-lg" data-id="element-180">
              <div className="bg-yellow-500 p-2 rounded-full mr-4" data-id="element-181">
                <CheckIcon className="h-5 w-5 text-black" data-id="element-182" />
              </div>
              <div data-id="element-183">
                <h3 className="font-bold text-lg mb-2" data-id="element-184">{feature.title}</h3>
                <p className="text-gray-300" data-id="element-185">{feature.description}</p>
              </div>
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-186">
          <p className="text-xl italic" data-id="element-187">
            This isn't just a book. It's a one-time print legacy piece designed
            to increase in value over time.
          </p>
        </div>
        <div className="mt-10 flex justify-center" data-id="element-188">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mEMi1okwpivnoSkTPeV87Q/Generated_Image_September_26%2C_2025_-_4_07PM.png" alt="Cristiano Ronaldo reading the Legacy #7 book" className="rounded-lg shadow-xl max-w-full md:max-w-lg h-auto" data-id="element-189" />
        </div>
      </div>
    </div>;
};